"use client";

import { Suspense } from "react";

import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { usePathname } from "next/navigation";

import { useAdminAccess } from "../utils/auth/useAdminAccess";
import { MenuItem } from "./MenuItem";
import UserBit from "./UserBit";

const menuItems = [
  { href: "/", label: "Início" },
  { href: "/edicoes/", label: "Edições" },
  { href: "/planos/", label: "Planos" },
];

const Header = () => {
  const { isAdmin } = useAdminAccess();
  const pathname = usePathname();

  return (
    <>
      <AppBar position="static" color="default" elevation={1}>
        <Toolbar>
          <Container
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              "& > *": {
                marginRight: 1,
              },
            }}
          >
            {menuItems.map((item) => (
              <MenuItem key={item.href} href={item.href} sx={{ marginLeft: 1 }}>
                {item.label}
              </MenuItem>
            ))}

            <Suspense>
              <UserBit component={<MenuItem href="/minha-conta/" transition="no" sx={{ marginLeft: 1 }} />} />
            </Suspense>

            {isAdmin && (
              <MenuItem href="/admin/" sx={{ marginLeft: 1 }} endIcon={<AdminPanelSettingsIcon />}>
                Admin
              </MenuItem>
            )}
          </Container>
        </Toolbar>
      </AppBar>

      <Box
        sx={{
          background: "url('/images/aaron-burden-149691-unsplash-cut.jpg')",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center center",
          backgroundSize: "cover",
          padding: "61px 0",
        }}
      >
        <Container>
          <Typography
            sx={{
              fontFamily: "'Roboto Slab', serif",
              fontSize: "3rem",
              color: "#fff",
              textShadow: "2px 2px 10px #0a0a0a",
              letterSpacing: "normal",
            }}
            variant="h1"
            // Article pages have their own <h1>; the site name is only the main heading on the home page.
            component={pathname === "/" ? "h1" : "p"}
          >
            Revista Leituras Cristãs
          </Typography>
          <Typography
            sx={{
              color: "#fff",
              textShadow: "2px 2px 10px #0a0a0a",
            }}
            variant="h3"
            component="h2"
          >
            Conteúdo cristão para edificação
          </Typography>
        </Container>
      </Box>
    </>
  );
};

export default Header;
